import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { LandingComponent } from 'Shared/components/landing/landing.component';

function check() {
  const token = localStorage.getItem('access_token');
  if (token) {
    return true;
  } else {
    return false;
  }
}

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('../app/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: check() ? '/user/main' : '/landing'
  },
  {
    path: 'landing',
    component: LandingComponent,
  },
  {
    path: 'shared',
    loadChildren: () => import('./shared/shared.module').then((m) => m.SharedModule),
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { 
}

